<template>
  <div class="article">
    <div class="title">Lady Athena Hung，Dato’ Sri, 2025Asia-Pacific Leaders Conference</div>
    <div class="info">作者：晴天集团    发布于：2025-06-29 14:08</div>
    <p>On April 8, 2025, the International Investment Salon of the Asia-Pacific Leaders Conference, hosted by Dr. Lawrence Yu, Founder of the Asia-Pacific Leaders Conference and Asia-Pacific Leaders Forum and Independent Director of the U.S. Rogers Pickleball Fund, grandly opened at the CFC Changfu Jinmao Building in Shenzhen. The event brought together more than 30 entrepreneurs, investors, financiers, and representatives from the cultural and sports sectors of China, Singapore, the United States, South Korea and other countries. Through the collision of cutting-edge ideas and in-depth cooperation discussions, they jointly explored new investment opportunities in the Asia-Pacific region.</p>
    <p>During the keynote speech session, industry leaders including Lady Athena Hung Chi Ching, Dato' Sri (Permanent Honorary Chairman of the Asia-Pacific Leaders Conference, renowned charity leader, Chairman of HCC  Group, 2023 Singapore Presidential Award recipient, and Chairman of THE HUNG CHI CHING CHARITABLE FUND, and Ms. Li Xiang (Vice President of Private Banking at J.P. Morgan Singapore), delivered in-depth sharing on hot topics such as technological innovation, cross-border capital, healthcare, and international investment. Guests like Sophie Harrison from the U.S. Harrison Fund and South Korean medical doctor Kim Hak-bong further analyzed the trend of industry-finance integration from a global perspective.</p>
    <p>As a significant part of the conference, Lady Athena Hung Chi Ching, Dato' Sri, was officially conferred the title of "Permanent Honorary Chairman of the Asia-Pacific Leaders Conference" for her outstanding contributions to promoting investment development and economic cooperation in the Asia-Pacific region. This honor is high recognition of her personal achievements but also makes her the only female leader to receive the highest honor from the Asia-Pacific Leaders Conference. It further signifies that she will shoulder more important responsibilities in the future, continuing to lead innovation and development in the investment sector of the Asia-Pacific region.<p>
    <p>The successful convening of the 2025 International Investment Salon of the Asia-Pacific Leaders Conference has established an efficient exchange and cooperation platform for investors in the Asia-Pacific region and even globally. The participation of Lady Athena Hung Chi Ching, Dato’ Sri, has undoubtedly injected new vitality and wisdom into the Asia-Pacific Leaders Conference. It is believed that under the leadership of Dame Hung, the Asia-Pacific Economic Leaders Federation will achieve more fruitful results in promoting regional economic development and advancing international investment cooperation.<p>
    <p>The Asia-Pacific Economic Leaders Federation has gathered numerous global economic leaders and thought leaders, with members including Fortune Global 500 enterprises, China 500 companies, and outstanding leaders from various industries in the Asia-Pacific region. Details are as follows: Dr. Lawrence Yu serves as the Founder and Chairman, who is also the Co-Chairman of APAC Asia-Pacific Leaders Investment Group (Dubai), Founder and Executive Chairman of the Belt and Road (AU) Bank, etc. The Honorary Presidents include more than 50 renowned Chinese business leaders such as Tan Yueng Kiat, Mochtar Riady, Wang Jianlin, Timothy Fok, and Zhang Ruimin.<p>
    <p>The guests attending the 2025 International Investment Salon of the Asia-Pacific Leaders Conference include: <p>
    <p>△ Lady Athena Hung Chi Ching, Dato’ Sri – Permanent Honorary Chairman of the Asia-Pacific Leaders Conference, Renowned Charity Leader, Chairman of HCC Group, 2023 Recipient of the Singapore Presidential Award, and Chairman of THE HUNG CHI CHING CHARITABLE FUND<p>
    <p>△ Ms. Sophie Harrison – North American Chairman of the Asia-Pacific Leaders Conference and Executive Chairman of the Harrison Fund (One of the Top Ten Families in the U.S.) <p>
    <p>△ Carlos Rogers – U.S.-China Sports Cooperation Ambassador of the Asia-Pacific Leaders Conference, Renowned NBA Championship Star, and Chairman of the U.S. Pickleball Fund Company （Ambassador for US - China Sports Cooperation for APELUA）<p>
    <p>△ Mr. Huo Yue - Chairman of the Chinese Culture Committee of the Asia-Pacific Leaders Conference, Initiator of the Asia-Pacific Global Private Directorate, and Founder of the Five Elements Thinking <p>
    <p>△ Mr. Chan Yiu Cheung - Vice Chairman of the Asia-Pacific Leaders Conference and Chairman of Hong Kong Baosheng Group <p>
    <p>△ Mr. Zhang Changguo - Famous Hong Kong Collector and Organizer of Silk Road City University <p>
    <p>△ Mr. Chen Zhi - Chairman of the Board of Directors of Hong Kong Causeway Bay Group <p>
    <p>△ Dr. Zeng Chengben - Founding Chairman of the Macau World Chinese Businessmen Foundation <p>
    <p>△ Mr. Zhang Guoqing - Vice Chairman of the China Urban-Rural Integration Development Alliance<p>
    <p>△ Dr. Kim Hak-bong (South Korea) - President of the Global Presidential Medical Advisors Alliance Special Invitation: Asia-Pacific Leaders Conference Overseas Wealth Management Team (Singapore):<p>
    <p>△ Ms. Li Xiang, Vice President and Bank Advisor for China Market, J.P. Morgan<p>
    <p>△ Ms. Wang Ning, Vice President, Private Banking, J.P. Morgan Singapore <p>
    <p>△ Ms. Tang Yisha, Wealth Consulting Advisor, Private Banking, J.P. Morgan</p>
    <p>On April 10, Lady Athena Hung Chi Ching, Dato’ Sri – Permanent Honorary Chairman of the Asia-Pacific Leaders Conference, renowned charity leader, investor, Chairman of HCC  Group, 2023 recipient of the Singapore Presidential Award, and Chairman of THE HUNG CHI CHING CHARITABLE FUND – and Dr. Lawrence Yu, Founder of the Asia-Pacific Economic Leaders Federation, visited the site of the FAW Logistics (Foshan) Multimodal Transport Smart Industrial Park project for an inspection tour.</p>
    <p>Lady Athena Hung Chi Ching has achieved remarkable success in the business sector. As a renowned philanthropist, investor, and the actual controller of a U.S.-listed company, she oversees a wide range of businesses spanning multiple key sectors. During the visit, accompanied by project leaders, Dame Hung gained a detailed understanding of the overall planning of the FAW Logistics (Foshan) Multimodal Transport Smart Industrial Park. The park's exploration and practices in this regard hold significant demonstrative value. Intelligent logistics facilities can not only enhance cargo handling efficiency but also strengthen the stability and reliability of logistics services, creating greater value for enterprises.</p>
    <img  src="@/assets/img/article/0629/1.webp" alt="">
    <p class="img-alt-content">Lady Athena Hung Chi Ching, Dato’ Sri, a renowned philanthropist and Chairman of the Board of HCC Group, engaged in in-depth discussions with guests on hot topics such as technological innovation, international capital, healthcare, and global investment.</p>
    <img  src="@/assets/img/article/0629/2.webp" alt="">
    <p class="img-alt-content">Lady Athena Hung Chi Ching, Dato’ Sri, a renowned philanthropist and Chairman of the Board of HCC Group, engaged in in-depth discussions with guests on hot topics such as technological innovation, international capital, healthcare, and global investment.</p>
    <img  src="@/assets/img/article/0629/3.webp" alt="">
    <p class="img-alt-content">Lady Athena Hung Chi ching, Dato’ Sri, a renowned philanthropist and Chairman of the Board of HCC Group, has been awarded the title of "Permanent Honorary Chairman of the Asia-Pacific Leaders Conference".</p>
    <img  src="@/assets/img/article/0629/4.webp" alt="">
    <p class="img-alt-content">Lady Athena Hung Chi Ching, Dato’ Sri, a renowned philanthropist and Chairman of the Board of HCC Group, took a group photo with the senior management of the Asia-Pacific Leaders Conference and guests.</p>
    <img  src="@/assets/img/article/0629/5.webp" alt="">
    <p class="img-alt-content">Lady Athena Hung Chi Ching, Permanent Honorary Chairman of the Asia-Pacific Leaders Conference, Visits and Inspects FAW (Foshan) Multimodal Transport Smart Industrial Park Project</p>
    <img  src="@/assets/img/article/0629/6.webp" alt="">
    <p class="img-alt-content">Lady Athena Hung Chi Ching, Permanent Honorary Chairman of the Asia-Pacific Leaders Conference, listened to the introduction of the project and conducted discussion and exchange.</p>
    <img  src="@/assets/img/article/0629/7.webp" alt="">
    <p class="img-alt-content">Lady Athena Hung Chi Ching, Permanent Honorary Chairman of the Asia-Pacific Leaders Conference (center), takes a group photo with Dr. Lawrence Yu, Founder of the Asia-Pacific Economic Leaders Federation (first from left), and the person in charge of the FAW (Foshan) Multimodal Transport Smart Industrial Park project.</p>
    <img  src="@/assets/img/article/0629/8.webp" alt="">
    <p class="img-alt-content">Lady Athena Hung Chi Ching, Permanent Honorary Chairman of the Asia-Pacific Leaders Conference (center), takes a group photo with Dr. Lawrence Yu, Founder of the Asia-Pacific Economic Leaders Federation (first from left), and senior executives of the FAW (Foshan) Multimodal Transport Smart Industrial Park project.</p>
    <img  src="@/assets/img/article/0629/9.webp" alt="">
    <p class="img-alt-content">Lady Athena Hung Chi Ching, Permanent Honorary Chairman of the Asia-Pacific Leaders Conference (center), takes a group photo with Dr. Lawrence Yu, Founder of the Asia-Pacific Economic Leaders Federation (first from left), and senior executives of the FAW (Foshan) Multimodal Transport Smart Industrial Park project.</p>
  </div>
</template>

<script>
export default {
  name: '1',
  components: {},
  data() {
    return {}
  }
}
</script>

<style scoped lang="scss">
.article{
  width: 70%;
  margin: 20px auto;
  font-family: $font-family;
  .title{
    font-size: 1.4rem;
    font-weight: bold;
    line-height: 50px;
    text-align: center;
  }

  .info{
    height: 28px;
    line-height: 28px;
    border-bottom: 1px #e8e8e8 solid;
    margin: 0;
    text-align: center;
    font-size: 0.8rem;
  }

  p{
    font-size: $content-font-size;
    color: #000000;
    line-height: 2;
    margin: 20px 0;
  }

  img{
    width: 60%;
    margin-left: 20%;
  }

  .img-alt{
    text-align: center;
    line-height: 1;
    margin: 6px 0;
    padding-top: 10px;
    color: #2f2e2e;
    font-size: 0.9rem;
  }

  .img-alt-content{
    text-align: center;
    line-height: 1;
    margin: 6px 0;
    padding-top: 5px;
    padding-bottom: 15px;
    color: #2f2e2e;
    font-size: 0.9rem;
  }
}

@media (max-width: 768px) {
  .article{
    width: 90%;
    margin: 20px auto;
    .title{
      padding-top: 10px;
      padding-bottom: 8px;
      font-size: 1.1rem;
      font-weight: bold;
      line-height: 1.3;
      text-align: center;
    }

    .info{
      height: 28px;
      line-height: 28px;
      border-bottom: 1px #e8e8e8 solid;
      margin: 0;
      text-align: center;
      font-size: 0.8rem;
    }

    p{
      font-size: $phone-content-font-size;
      color: #000000;
      line-height: 2;
      margin: 20px 0;
    }

    img{
      width: 80%;
      margin-left: 10%;
    }

    .img-alt{
      text-align: center;
      line-height: 1;
      margin: 6px 0;
      color: #2f2e2e;
      padding-top: 5px;
      font-size: 0.8rem;
    }
    .img-alt-content{
      text-align: center;
      line-height: 1;
      margin: 6px 0;
      padding-top: 5px;
      padding-bottom: 15px;
      color: #2f2e2e;
      font-size: 0.8rem;
    }
  }
}

@media (max-width: 480px) {
  .article{
    width: 100vw;
    padding: 0 10px;
    box-sizing: border-box;
    margin: 20px auto;
    .title{
      padding-top: 10px;
      padding-bottom: 8px;
      font-size: 1.1rem;
      font-weight: bold;
      line-height: 1.3;
      text-align: center;
    }

    .info{
      height: 28px;
      line-height: 28px;
      border-bottom: 1px #e8e8e8 solid;
      margin: 0;
      text-align: center;
      font-size: 0.8rem;
    }

    p{
      font-size: $phone-content-font-size;
      color: #000000;
      line-height: 2;
      margin: 20px 0;
    }

    img{
      width: 100%;
      margin: 0;
    }

    .img-alt{
      text-align: center;
      line-height: 1;
      font-size: 0.7rem;
      margin: 6px 0;
      color: #666;
    }
  }
}
</style>
